/**
* @param {Object.<string,Object>} object
*/
module.exports = function createPathSelector(object) {
    /**
     * @param {string} pathString
     * @param {Array<String|Number>} placeholders
     */
    function pathSelector(pathString, placeholders = []) {
        const path = pathString.split('.');
        let search = object;
        for (const key of path) {
            if (typeof search[key] === 'undefined') {
                console.error(`Translation path ${pathString} not found.`);
                return pathString;
            }

            // @ts-ignore
            search = search[key];
        }

        if (typeof search !== 'string') {
            console.error(`Translation path ${pathString} is not a string.`);
            return pathString;
        }

        for (const placeholder of placeholders) {
            // @ts-ignore
            search = search.replace('%s', placeholder);
        }

        return search;
    }

    Object.assign(pathSelector, object);

    return pathSelector;
};
